import {
  EInvoiceTransactionReupload,
  GridTable,
  LoadingBox,
  PrivilegesChecker,
  SearchEInvoiceTransactionFields
} from "..";
import {
  PageEnum,
  RequestActionModel,
  TableActionColumnsStyleEnum,
  ActionTypeEnum,
} from "../../models";
import {
  convertDateToLocalIsoDate,
  isArabicCurrentLanguage,
  scrollToDocumentTop,
} from "../../utils";

import { useSearchParams } from "react-router-dom";
import { useEinvoiceTransaction } from "../../hooks/einvoiceTransaction/useEinvoiceTransaction";
import {addDays} from "date-fns";


export const EInvoiceTransactionList = () => {
  //#region variables
  const isArabic = isArabicCurrentLanguage();
  let [_, setSearchParams] = useSearchParams();
  const {
    data,
    loading,
    searchParams,
    totalCount,
    fetchData,
    updateSearchParam,
    resetSearch,
    onCurrentPageChange,
    onPageSizeChange,
  } = useEinvoiceTransaction({
    isSuccess: true,
    fromDate: convertDateToLocalIsoDate(addDays(new Date(), -7))?? new Date(),
    toDate: convertDateToLocalIsoDate(addDays(new Date(),0))?? new Date(),
  });
 //#endregion
  //#region functions
  const handleSearch = async () => {
   await  fetchData();
  };
  const handleReset = async () => {
    resetSearch();
    await fetchData({});
  };
  function handleUpdate(event: number | string) {
    const encodedId = btoa(event.toString()); // Base64 encode
    setSearchParams({
      id: encodedId,
    });
    scrollToDocumentTop();
  }
  const onActionEvent = (e: RequestActionModel) => {
    if (
      e.action === ActionTypeEnum.View ||
      e.action === ActionTypeEnum.Update
    ) {
      handleUpdate(e?.id || "");
      return;
    }
  };
  //#endregion
  //#region html
  return (
    <LoadingBox isLoading={loading}>
      <PrivilegesChecker
        formId={PageEnum.ManageEInvoices}
        action="EnableSearch"
      >
        <SearchEInvoiceTransactionFields
          searchParams={searchParams}
          onUpdateSearchParam={updateSearchParam}
          onSearch={handleSearch}
          onReset={handleReset}
          loading={loading}
        />
      </PrivilegesChecker>
      {data?.length ? (
        <>
          <div className="border border-1 border-gray w-100 my-4"></div>
          <EInvoiceTransactionReupload
            key={JSON.stringify(searchParams)}
            data={data}
          />
        </>
      ) : null}

      <GridTable
        data={data}
        totalRows={totalCount}
        currentPage={searchParams.pageNumber || 1}
        pageSize={searchParams.pageSize || 50}
        onCurrentPageChange={onCurrentPageChange}
        onPageSizeChange={onPageSizeChange}
        paginationType="server"
        externalLoading={loading}
        formId={PageEnum.ManageEInvoices}
        columnsProps={{
          actions: [],
          onActionEvent,
          isArabic,
        }}
        style={TableActionColumnsStyleEnum.Dropdown}
        useRowBasedActions={true}
      />
    </LoadingBox>
  );
};
//#endregion